import React, {Fragment, PureComponent} from 'react';
import PropTypes from 'prop-types';
import {TextField} from '../../../common';

const PREFIX = 'f_';

export default class UserAdvances extends PureComponent {
  static propTypes = {
    userDefinitions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    fetchUserDefinitions: PropTypes.func.isRequired,
    editMode: PropTypes.bool,
  };

  static defaultProps = {
    userDefinitions: [],
  };

  componentDidMount() {
    this.props.fetchUserDefinitions();
  }

  renderDefinitions = () => {
    const {userDefinitions, editMode} = this.props;

    return (
      userDefinitions.map(definition => (
        <TextField
          label={definition.field}
          labelClass="col-3 text-right"
          inputClass="col-9"
          name={`${PREFIX}${definition.field}`}
          key={`${PREFIX}${definition.field}`}
          required
          isRow
          readOnly={!editMode}
        />
      ))
    );
  }

  render() {
    return (
      <Fragment>
        <h2 className="advanced-field__heading">Additional Profile Information</h2>
        {
          this.renderDefinitions()
        }
      </Fragment>
    );
  }
}
